import { render } from "./PopUpDuplicateClassLink.vue?vue&type=template&id=33d2fd0c"
import script from "./PopUpDuplicateClassLink.vue?vue&type=script&lang=js"
export * from "./PopUpDuplicateClassLink.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__